import {useEffect, useState} from 'react';

export const useLoadingText = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots((prevDots) => (prevDots.length < 3 ? `${prevDots}・` : ''));
    }, 800); // 800ミリ秒（1秒）ごとに更新

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return {dots};
};

export const useLoadingProgress = (mseconds: number) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          clearInterval(interval);
          return 100;
        }

        const increase = 100 / (mseconds / 100);
        return Math.min(oldProgress + increase, 100);
      });
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, [mseconds]);

  return {progress};
};
